import { commonUtil } from '@/util'
const request = {}

request.createRequest = function (params) {
  const tmpProduct = params.productList.map((ele) => {
    const tmpRackInfo = ele.rackInfoList.map((ele2) => {
      return {
        quantity: ele2.quantity,
        rackNumber: commonUtil.nullEmptyFormatNull(ele2.rackNumber)
      }
    })
    return { productId: ele.productId, rackInfoList: tmpRackInfo }
  })
  return {
    arrivalDate: params.pageInfoData.arrivalDate,
    arrivalProductList: tmpProduct
  }
}
export default { request }
